import React from 'react';
import { MenuOutlined } from '@ant-design/icons';

interface MenuIconWithBadgeProps {
    count: number; // 动态数字
}

const MenuIconWithBadge: React.FC<MenuIconWithBadgeProps> = ({ count }) => {
    return (
        <div className="relative">
            <MenuOutlined />
            {count > 0 && (
                <span
                    className="absolute top-0 right-0 left-4 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs"                >
                    {count > 99 ? '99+' : count}
                </span>
            )}
        </div>
    );
};

export default MenuIconWithBadge;
